import React, { PureComponent } from 'react'
import CheckboxInput from 'components/checkbox/checkbox'

class CheckboxInputForm extends PureComponent {

	render() {
		return <CheckboxInput
			styleName={'cta_checkbox'}
			status={this.props.fieldStatus(this.props.meta, this.props.name)}
			onChange={this.props.input.onChange}
			value={this.props.input.value}
			id={this.props.id}
		/>
	}
}

CheckboxInputForm.defaultProps = {
	id: '',
	fieldStatus: () => '',
}

export default CheckboxInputForm
